/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { getUserByToken, login } from '../core/_requests'
import { KTIcon } from '../../../../_metronic/helpers'
import { useAuth } from '../core/Auth'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Formato de Correo Incorrecto')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Correo es requerido'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Contraseña es requerida'),
})

const initialValues = {
  email: '',
  password: '',
}

/*-
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const { saveAuth, setCurrentUser } = useAuth()
  const [mensajeError, setMensajeError] = useState(false)

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const formik = useFormik({
    initialValues, validationSchema: loginSchema, onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        const { data: auth } = await login(values.email, values.password)

        saveAuth(auth)
        const { data: user } = await getUserByToken(auth.api_token)
        setCurrentUser(user)
        window.location.reload();
      } catch (error) {
        setMensajeError(true)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form className='form w-100' onSubmit={formik.handleSubmit} noValidate id='kt_login_signin_form' >
      {/* Encabezado */}
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Iniciar Sesión</h1>
      </div>

      {mensajeError &&
        <div style={{ textAlign: 'center', color: 'red', fontSize: '15px' }}>Credenciales Incorrectas</div>}

      {/* Solicita Correo */}
      <div className='fv-row mb-8'>
        <div className="form-floating">
          <input placeholder='Correo' {...formik.getFieldProps('email')} type='email' name='email' autoComplete='off' className={clsx('form-control bg-transparent',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            { 'is-valid': formik.touched.email && !formik.errors.email, }
          )} />
          <label htmlFor='email'>Correo</label>
        </div>
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>

      {/* Solicita contraseña */}
      <div className='fv-row mb-3'>
        <div className="form-floating">
          <input placeholder='Contraseña'
            {...formik.getFieldProps('password')}
            type={showPassword ? 'text' : 'password'} autoComplete='off'
            className={clsx('form-control position-relative bg-transparent',
              { 'is-invalid': formik.touched.password && formik.errors.password, },
              { 'is-valid': formik.touched.password && !formik.errors.password, }
            )} />
          <label htmlFor='password'>Contraseña</label>
          <div className="position-absolute end-0 top-50 translate-middle-y pointer me-10" onClick={togglePasswordVisibility}>
            {showPassword ?
              <KTIcon iconName='eye-slash' className=' fs-1' /> :
              <KTIcon iconName='eye' className=' fs-1' />}
          </div>
        </div>

        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>

      {/* Sección Olvidaste Contraseña */}
      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <Link to='/auth/forgot-password' className='link-primary'> ¿Olvidaste Contraseña? </Link>
      </div>

      {/* Boton de Submit */}
      <div className='d-grid mb-10'>
        <button type='submit' id='kt_sign_in_submit' className='btn btn-primary' disabled={formik.isSubmitting || !formik.isValid}>
          {!loading && <span className='indicator-label'>Iniciar Sesión</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Cargando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to='/auth/registration' className='link-primary'>
          Sign up
        </Link>
      </div> */}
    </form>
  )
}
